const PercentageSymbol = () => {
  return (
    <>
      {/* percentage */}

      <span className="ratewise">
        <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path
            d="M0.481 2.85C0.481 2.19133 0.671667 1.67567 1.053 1.303C1.443 0.930333 1.94133 0.744 2.548 0.744C3.15467 0.744 3.64867 0.930333 4.03 1.303C4.42 1.67567 4.615 2.19133 4.615 2.85C4.615 3.51733 4.42 4.03733 4.03 4.41C3.64867 4.78267 3.15467 4.969 2.548 4.969C1.94133 4.969 1.443 4.78267 1.053 4.41C0.671667 4.03733 0.481 3.51733 0.481 2.85ZM8.827 0.899999L3.718 10H1.95L7.046 0.899999H8.827ZM2.535 1.836C2.05833 1.836 1.82 2.174 1.82 2.85C1.82 3.53467 2.05833 3.877 2.535 3.877C2.769 3.877 2.951 3.79467 3.081 3.63C3.211 3.45667 3.276 3.19667 3.276 2.85C3.276 2.174 3.029 1.836 2.535 1.836ZM6.188 8.037C6.188 7.36967 6.37867 6.854 6.76 6.49C7.15 6.11733 7.64833 5.931 8.255 5.931C8.86167 5.931 9.35133 6.11733 9.724 6.49C10.1053 6.854 10.296 7.36967 10.296 8.037C10.296 8.70433 10.1053 9.22433 9.724 9.597C9.35133 9.96967 8.86167 10.156 8.255 10.156C7.63967 10.156 7.14133 9.96967 6.76 9.597C6.37867 9.22433 6.188 8.70433 6.188 8.037ZM8.242 7.023C7.748 7.023 7.501 7.361 7.501 8.037C7.501 8.72167 7.748 9.064 8.242 9.064C8.72733 9.064 8.97 8.72167 8.97 8.037C8.97 7.361 8.72733 7.023 8.242 7.023Z"
            fill="#FFA600"
          />
        </svg>
      </span>
    </>
  );
};
export default PercentageSymbol;
